import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ComumModule } from './../../../shared/comum.module';
import { translateLoaderNBS } from './../../../shared/translate-loader/translateLoader';
import { MargemMOCadastroComponent } from './margem-mo-cadastro/margem-mo-cadastro.component';
import { MargemMOFiltroComponent } from './margem-mo-filtro/margem-mo-filtro.component';
import { MargemMOListaComponent } from './margem-mo-lista/margem-mo-lista.component';
import { MargemMOService } from './margem-mo-service/margem-mo.service';
import { MargemMOComponent } from './margem-mo.component';
import { FileUploadModule } from './../../../shared/fileupload/fileupload';

@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS),
    FileUploadModule
  ],
  exports: [
    MargemMOComponent
  ],
  declarations: [
    MargemMOComponent,
    MargemMOCadastroComponent,
    MargemMOListaComponent,
    MargemMOFiltroComponent
  ],
  providers: [
    MargemMOService
  ]
})
export class MargemMOModule { }
